module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('section', [_c('carousel', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    attrs: {
      "navigationEnabled": true,
      "navigationNextLabel": '',
      "navigationPrevLabel": '',
      "perPage": 1,
      "paginationActiveColor": '#f58466',
      "paginationColor": '#dedede',
      "navigationClickTargetSize": 5,
      "paginationPadding": 5,
      "paginationSize": 14
    }
  }, [_vm._l((_vm.props.video_slider), function(slide, i) {
    return (_vm.props.video_slider) ? [((slide.image.value.length)) ? _c('slide', {
      staticClass: "VueCarousel-video image-container",
      style: (_vm.setBackgroundImage(slide.image.value[0].url)),
      attrs: {
        "data-name": slide.vimeo_id.value,
        "data-videoID": 'video_' + i
      },
      on: {
        "slideClick": _vm.handleSlideClick
      }
    }, [_c('div', {
      staticClass: "play-button",
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "data-video-id": slide.vimeo_id.value
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "embed-container",
      attrs: {
        "id": 'video_' + i
      }
    })]) : _c('slide', {
      staticClass: "video-container"
    }, [_c('div', {
      staticClass: "embed-container"
    }, [_c('iframe', {
      attrs: {
        "src": 'https://player.vimeo.com/video/' + slide.vimeo_id.value + '?loop=1&title=0&byline=0&portrait=0&api=1',
        "width": "640",
        "height": "360",
        "frameborder": "0",
        "allow": "autoplay; fullscreen",
        "allowfullscreen": ""
      }
    })])])] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.props.slider_images.value), function(slide) {
    return (_vm.props.slider_images.value.length) ? [_c('slide', {
      staticClass: "image-container"
    }, [_c('div', {
      staticClass: "bg-inside",
      style: (_vm.setBackgroundImage(slide.url))
    }, [_c('img', {
      attrs: {
        "src": slide.url,
        "alt": slide.name
      }
    })])])] : _vm._e()
  })], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d565850","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/porfolio.vue
// module id = 1536
// module chunks = 0